import { useState, useEffect, startTransition } from 'react';

// This hook is used to determine if we should continue to render the server placeholder
// during hydration on the first render to prevent mismatch. If mismatch occurs, hydration
// can break.
export const useRenderServerPlaceholder = (renderServerPlaceholderOnNonHydrate = false): any => {
	const isTransition = window.__SSR_RENDERED__ === false;
	const [renderServerPlaceholder, setRenderServerPlaceholder] = useState(
		renderServerPlaceholderOnNonHydrate
			? // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
				!isTransition || Boolean(process.env.REACT_SSR)
			: // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
				((window as any)?.__HYDRATABLE__ && !isTransition) || Boolean(process.env.REACT_SSR),
	);

	useEffect(() => {
		// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
		if (!process.env.REACT_SSR) {
			// Clearing the placeholder synchronously can land on a Suspense boundary that has
			// not finished hydrating, which makes React discard the server HTML for that
			// boundary and client-render it instead.
			if (window.__SSR_RENDERED__) {
				startTransition(() => {
					setRenderServerPlaceholder(false);
				});
			} else {
				setRenderServerPlaceholder(false);
			}
		}
	}, []);

	return renderServerPlaceholder;
};
